import { WorkflowState } from '@/types/workflows'

/**
 * Split workflow-state ids into the "Done" bucket and the "fast" bucket. Done
 * states are typically the slow, high-volume, low-churn ones (their counts can
 * be polled less often); everything else — Intake, In Progress, and any
 * untyped/unassigned state — goes in the fast bucket so nothing goes stale.
 *
 * The legacy "processing" state (a holdover on labeling/categorization ML
 * workflows) is skipped entirely — we don't surface a count for it.
 */
export function partitionWorkflowStateIdsByDoneness(
  workflowStates: WorkflowState[],
) {
  return workflowStates.reduce<{
    doneStateIds: string[]
    fastStateIds: string[]
  }>(
    (acc, state) => {
      if (state.code === 'processing') {
        return acc
      }
      if (state.workflow_state_type?.code === 'done') {
        acc.doneStateIds.push(state.id)
      } else {
        acc.fastStateIds.push(state.id)
      }
      return acc
    },
    { doneStateIds: [], fastStateIds: [] },
  )
}

export function getWorkflowStatesByType(workflowStates: WorkflowState[]) {
  return workflowStates.reduce<Record<string, WorkflowState[]>>(
    (acc, state) => {
      if (!state.workflow_state_type) {
        acc['unassigned'] ||= []
        acc['unassigned'].push(state)
      } else {
        acc[state.workflow_state_type.code] ||= []
        acc[state.workflow_state_type.code].push(state)
      }
      return acc
    },
    {},
  )
}

export function getWorkflowStateGroupsBySortOrder(
  workflowStates: WorkflowState[],
) {
  const statesByType = getWorkflowStatesByType(workflowStates)
  return Object.values(statesByType).sort((a, b) => {
    return a[0].sort_order - b[0].sort_order
  })
}
